const ACTION_TYPES = {
    RESET_CREATION_STATE: 'RESET_CREATION_STATE',
    SET_PORTFOLIO_DESCRIPTION: 'SET_PORTFOLIO_DESCRIPTION',
    SET_NEW_PORTFOLIO_NAME: 'SET_NEW_PORTFOLIO_NAME',
    SET_PORTFOLIO_PRIVACY: 'SET_PORTFOLIO_PRIVACY',
    SET_NOTE: 'SET_NOTE',
    SET_NOTE_IMAGE: 'SET_NOTE_IMAGE',
    SET_NOTE_TITLE: 'SET_NOTE_TITLE',
};

function resetCreationState() {
    return { type: ACTION_TYPES.RESET_CREATION_STATE };
}

function setPortfolioDescription({ newPortfolioDescription }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_DESCRIPTION, newPortfolioDescription };
}
function setNewPortfolioName({ newPortfolioName }) {
    return { type: ACTION_TYPES.SET_NEW_PORTFOLIO_NAME, newPortfolioName };
}

function setPortfolioPrivacy({ newPortfolioPrivacy }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_PRIVACY, newPortfolioPrivacy };
}

function setNote({ note }) {
    return { type: ACTION_TYPES.SET_NOTE, note };
}

function setNoteImage({ noteImage }) {
    return { type: ACTION_TYPES.SET_NOTE_IMAGE, noteImage };
}

function setNoteTitle({ noteTitle }) {
    return { type: ACTION_TYPES.SET_NOTE_TITLE, noteTitle };
}

export default {
    ...ACTION_TYPES,
    resetCreationState,
    setPortfolioDescription,
    setNewPortfolioName,
    setPortfolioPrivacy,
    setNote,
    setNoteImage,
    setNoteTitle,
};
